<template>
  <div class="pod-status">
    <span style="display: none">{{docket.deliveryStatus}}</span>
    <span style="display: none">{{docket.returnLrNo}}</span>
    <span class="text-success" v-if="docket.deliveryStatus === 'DELIVERED' && (docket.returnLrNo === null || docket.returnLrNo.trim().length === 0)">
      <i class="fas fa-check-circle"></i> {{docket.actualDeliveryDate|date}}
    </span>
    <span class="text-danger" v-if="docket.deliveryStatus === 'RTO' || (docket.returnLrNo !== null && docket.returnLrNo.trim().length > 0)">
      <i class="fas fa-redo"></i> {{docket.actualDeliveryDate|date}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'DeliveryStatus',
  props: ['docket'],
  data () {
    return {}
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>
  .pod-status {
    width: 120px;
    white-space: nowrap;
    text-align: center;
    margin: auto;
  }
  .table-sm .pod-status {
    width: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/DeliveryStatus.vue